import { Field as ChakraField, Fieldset } from '@chakra-ui/react';
import { CockpitFormLayout } from '@components/cockpit/layouts/CockpitFormLayout';
import ModifiedTag from '@components/common/form/ModifiedField';
import TupleList from '@components/ui/TupleList';
import { areSelectedFieldsEqual } from '@utils/common.utils';
import { useFormikContext } from 'formik';
import { FormattedMessage } from 'react-intl';

import { ChipTypeEnum, NormalizedFleet } from '@/types/utm/fleet.type';

export default function ChipsTab() {
  const { errors, touched, initialValues, values, setFieldValue } = useFormikContext<NormalizedFleet>();

  return (
    <CockpitFormLayout title="components.utm.fleets.tab.chips.title">
      <Fieldset.Root invalid={Object.keys(errors).some((key) => touched[key as keyof typeof touched])}>
        <ChakraField.Root variant="cockpit">
          <ChakraField.Label width="100%" height="20px">
            <FormattedMessage id="components.utm.fleets.tab.chips.title" />
            {!areSelectedFieldsEqual(values, initialValues, ['chips']) && <ModifiedTag />}
          </ChakraField.Label>
          <TupleList<ChipTypeEnum>
            items={values.chips}
            enumList={Object.values(ChipTypeEnum)}
            onChange={(values) => setFieldValue('chips', values)}
          />
        </ChakraField.Root>
      </Fieldset.Root>
    </CockpitFormLayout>
  );
}
